export function getSearchPage(state: any) {
    return state.search.list;
}

export function getLastSearchValue(state: any) {
    return state.search.searchValue;
}

export function hasMore(state: any) {
    const { rows, meta } = getSearchPage(state);

    return meta.totalSize > rows.length;
}

export function isLoading(state: any) {
    return state.search.isLoading;
}
